import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="account-mapping-compatibility"
export default class extends Controller {
  static targets = ['suffix', 'wrapper', 'hint']

  declare readonly suffixTarget: HTMLInputElement
  declare readonly wrapperTarget: HTMLElement
  declare readonly hasHintTarget: boolean
  declare readonly hintTarget: HTMLElement

  refresh(): void {
    const enabled = this.suffixTarget.checked
    this.wrapperTarget.classList.toggle('select2-container--disabled', !enabled)
    if (this.hasHintTarget) {
      this.hintTarget.classList.toggle('tw-hidden', enabled)
    }
  }
}
